<template>
  <div class="scorecard-header">
    <header v-if="layout == 'topic'">
      <h4 class="f-title-6">{{ topic }}</h4>
      <p class="f-ui-1">
        {{ familyName }}
      </p>
    </header>
    <header v-else>
      <span class="f-ui-2 breadcrumbs">{{ family || topic }}</span>
      <p class="scorecard-policy-type f-ui-1-bold">{{ policyType }}</p>
      <!--
      <div class="scorecard-header__description">
        <p class="f-ui-3">
          {{ description }}
        </p>
      </div>
      -->
    </header>
    <a
      class="scorecard-detail"
      target="_blank"
      :href="policyType ? policyTypeLink : topicLink"
      :title="
        policyType
          ? `View all ${policyType} policies`
          : `View all ${topic} policies`
      "
    >
      <span class="f-ui-2">View policies</span>
      <Icon :icon="'circle-arrow'" class="arrow-right" />
    </a>
  </div>
</template>

<script>
import { Icon } from "@international-energy-agency/vue-ui";
import familyNames from '@/assets/familyNames.json'
export default {
  props: {
    topic: {
      type: String,
      required: true,
    },
    family: {
      type: String,
      required: false,
      default: null,
    },
    policyType: {
      type: String,
      required: false,
      default: null,
    },
    layout: {
        type: String,
        validator: (value) => ['topic','policyType'].includes(value),
        default: 'default'
    },
    test: {
      type: Boolean,
      default: false,
    },
  },
  components: { Icon },
  computed: {
    topicLink() {
      const { topic, family, test } = this;
      return `https://${
        test ? "test" : "www"
      }.iea.org/policies/?topic=${topic}${
        family !== "All" ? `&type=${family}` : ""
      }`;
    },
    policyTypeLink() {
      const { topicLink, policyType } = this;
      return `${topicLink}&type=${policyType}`;
    },
    familyName() {
      const { family } = this;
      if (!family) return 'All policies';
      return familyNames[family] || family;
    },
  },
};
</script>


<style scoped>
.scorecard-header {
  position: relative;
  height: 140px;
  border-bottom: 1px solid #949494;
  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */
}

.scorecard-header header {
  min-height: 80px;
  max-width: 240px;
}
.scorecard-header header h4 {
  margin-bottom: 4px;
}
.scorecard-header__description {
  /* height: 140px; */
  overflow-y: auto;
}
.scorecard-header p {
  margin-bottom: 0px !important;
}
.--region-list .scorecard-header {
  border-bottom: none;
}
/*
.--region-list header,
.--region-list .scorecard-detail {
  display: none;
  visibility: hidden;
}
*/
.scorecard-header .scorecard-policy-type {
  min-height: 2.5rem;
}
/* Detail link */
.scorecard-detail {
  display: inline-flex;
  position: absolute;
  bottom: 4px;
  cursor: pointer;
  align-items: center;
  margin: 10px 0px;
  color: #04f;
  text-decoration: none;
  box-shadow: none;
}
.scorecard-detail:before {
  transition-property: opacity;
  transition-duration: 0.2s;
  transition-timing-function: ease-out;
  background-color: #04f;
  position: absolute;
  top: -4px;
  right: -4px;
  bottom: -4px;
  left: -10px;
  border-radius: 14px;
  content: "";
  opacity: 0;
  z-index: 0;
  pointer-events: none;
}
.scorecard-detail:hover:before {
  opacity: 0.15;
}
.arrow-right {
  vertical-align: middle;
  margin-left: 4px;
}
</style>